import React from 'react'
import {ModalBody, ModalContent, ModalFooter, ModalHeader} from '../../components/ui/Modal';
import {LoaderContainer, LoaderEnum, MiniLoader} from "../Loader/MiniLoader";
import {ModalActiveBtn, ModalBtnText, ModalDefaultBtn, ModalDisabledBtn} from "../../components/ui/Button";
import {useTheme} from "styled-components";
import {ModalTitleContent} from "../../components/ui/Content";
import {BackArrow} from "../../icon/Icon";
import {Title} from "../../components/Font";

export interface ModalProps {
    title: string
    disable?: boolean
    onSubmit: () => void
    content: () => JSX.Element | React.ReactElement
    submitText?: string
    isFetching?: boolean
    onClose?: () => void
    noArrow?: boolean
}

export const Modal = ({
                          title,
                          disable,
                          onSubmit,
                          content,
                          submitText,
                          isFetching,
                          onClose,
                          noArrow
                      }: ModalProps) => {
    const Theme = useTheme()
    return <ModalContent>
        <ModalHeader>
            <ModalTitleContent>
                {!noArrow && <BackArrow onClick={onClose}/>}
                <Title>
                    {title}
                </Title>
            </ModalTitleContent>
        </ModalHeader>
        {content && <ModalBody>
            {content()}
        </ModalBody>}
        <ModalFooter>
            <ModalDefaultBtn onClick={onClose}>
                Отмена
            </ModalDefaultBtn>
            <ModalActiveBtn
                as={disable ? ModalDisabledBtn : ModalActiveBtn}
                onClick={() => {
                    if (!disable && !isFetching) {
                        onSubmit()
                    }
                }}>
                <ModalBtnText style={{opacity: isFetching ? '0' : '1'}}>
                    {submitText || 'Сохранить'}
                </ModalBtnText>
                {isFetching && <LoaderContainer>
                    <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                </LoaderContainer>}
            </ModalActiveBtn>
        </ModalFooter>
    </ModalContent>
}
